// extracted by mini-css-extract-plugin
module.exports = {"pagination":"s_pagination__1zvn3","arrowLink":"s_arrowLink__2jS0T","pageLink":"s_pageLink__1kCnq","pageLinkActive":"s_pageLinkActive__1_Gm6"};